<template>
	<div>
		<b-modal
			id="modal-prevent-closing"
			ref="modal"
			:title="getText('session_short')"
			size="md"
			centered
			hide-header-close
			ok-only
			@hide="close"
		>
			<div class="text-center">
				<!-- <h4 class="mb-3">{{ getText('modal_code_title') }}</h4>
				<h1 class="display-4 border border-2 px-5 py-1" style="display: inline-block; border-radius: 100em;">{{ code }}</h1>
				<p class="mt-3 mb-0">{{ getText('modal_code_explanation') }}</p> -->
				<h4 class="mb-3">
					Your performance
				</h4>
				<h1 class="display-4 border border-2 px-5 py-1" style="display: inline-block; border-radius: 100em;">
					{{ performance }} / 100
				</h1>
				<!-- <p class="mt-3 mb-0">
					Difficulty: {{ behavior }}
				</p> -->

				<hr />

				<h6 class="text-start mb-3">Change difficulty</h6>
				<div class="d-flex gap-2">
					<button
						class="btn"
						:class="{
							'btn-primary': behavior == 'ADAPTIVE',
							'btn-outline-secondary': behavior != 'ADAPTIVE',
						}"
						@click="setBehavior('ADAPTIVE')"
					>
						Adaptive
					</button>
					<button
						class="btn"
						:class="{
							'btn-primary': behavior == 'RANDOM',
							'btn-outline-secondary': behavior != 'RANDOM',
						}"
						@click="setBehavior('RANDOM')"
					>
						Random
					</button>
					<div class="border"></div>
					<button
						class="btn"
						:class="{
							'btn-primary': behavior == 'EASY',
							'btn-outline-secondary': behavior != 'EASY',
						}"
						@click="setBehavior('EASY')"
					>
						Easy
					</button>
					<button
						class="btn"
						:class="{
							'btn-primary': behavior == 'MEDIUM',
							'btn-outline-secondary': behavior != 'MEDIUM',
						}"
						@click="setBehavior('MEDIUM')"
					>
						Medium
					</button>
					<button
						class="btn"
						:class="{
							'btn-primary': behavior == 'HARD',
							'btn-outline-secondary': behavior != 'HARD',
						}"
						@click="setBehavior('HARD')"
					>
						Hard
					</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>



<script>
	export default {
		data() {
			return {
				performance: -1,
				behavior: "behavior",
				oldBehavior: "behavior",
				onChangeBehavior: new Event('onChangeBehavior'),
			}
		},
		methods: {
			open() {
				this.$refs.modal.show();
				this.$log.onShowModal("difficulty", true);

				this.performance = Math.floor(this.$tracker.performanceValue);
				this.behavior = this.$tracker.behavior;
				this.oldBehavior = this.$tracker.behavior;
			},
			close() {
				this.$log.onShowModal("difficulty", false);

				if (this.behavior != this.oldBehavior) {
					// Force reload of page
					const path = this.$route.path;
					this.$router.replace({ name: "Home" });
					setTimeout(() => {
						this.$router.replace(path);
					}, 200);

					// Announce change since tracker is not responsive
					window.dispatchEvent(this.onChangeBehavior);
				}
			},

			setBehavior(behavior) {
				this.$tracker.behavior = behavior;
				this.behavior = behavior;
			}
		}
	}
</script>



<style scoped>
</style>
